import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable()
export class JudgePowerliftingProvider {

  constructor(private db: AngularFireDatabase) { }

  updateLastUpdated(meetId) {
    // console.log('oppdaterer sist endret dato');
    this.db.object('/meets/' + meetId).update({
      last_updated: Date.now()
    });
  }

  resetResultat(meetId) {
    // console.log('kaller resetResultat()');
    const resetTimer = 11 * 1000 // 11 sek
    const result = this.db.object('/results/' + meetId);

    setTimeout(function () {
      // console.log('sletter resultat object');
      result.remove();
    }, resetTimer);
  }

  goodLift(position, meetId, regret) {
    // dommer posisjon
    if (position === 'left' || position === 'left-test') {

      // regret choice
      if (regret) {
        this.db.object('/results/' + meetId).update({
          referee_left_red: null,
          referee_left_blue: null,
          referee_left_yellow: null,
          referee_left: 1,
        });
      }
      else {
        this.db.object('/results/' + meetId).update({
          referee_left: 1
        });
      }
    }

    if (position === 'head' || position === 'head-test') {

      // regret choice
      if (regret) {
        this.db.object('/results/' + meetId).update({
          referee_head_red: null,
          referee_head_blue: null,
          referee_head_yellow: null,
          referee_head: 1,
        });
      }
      else {
        this.db.object('/results/' + meetId).update({
          referee_head: 1
        });
      }
    }

    if (position === 'right' || position === 'right-test') {

      // regret choice
      if (regret) {
        this.db.object('/results/' + meetId).update({
          referee_right_red: null,
          referee_right_blue: null,
          referee_right_yellow: null,
          referee_right: 1,
        });
      }
      else {
        this.db.object('/results/' + meetId).update({
          referee_right: 1
        });
      }
    }
  }

  redCard(position, meetId) {
    if (position == 'left' || position === 'left-test') {
      this.db.object('/results/' + meetId).update({
        referee_left: 0,
        referee_left_red: 0
      });
    }

    if (position == 'head' || position === 'head-test') {
      this.db.object('/results/' + meetId).update({
        referee_head: 0,
        referee_head_red: 0
      });
    }

    if (position == 'right' || position === 'right-test') {
      this.db.object('/results/' + meetId).update({
        referee_right: 0,
        referee_right_red: 0
      });
    }
  }

  blueCard(position, meetId) {
    if (position == 'left' || position === 'left-test') {
      this.db.object('/results/' + meetId).update({
        referee_left: 0,
        referee_left_blue: -1
      });
    }

    if (position == 'head' || position === 'head-test') {
      this.db.object('/results/' + meetId).update({
        referee_head: 0,
        referee_head_blue: -1
      });
    }

    if (position == 'right' || position === 'right-test') {
      this.db.object('/results/' + meetId).update({
        referee_right: 0,
        referee_right_blue: -1
      });
    }
  }

  yellowCard(position, meetId) {
    if (position == 'left' || position === 'left-test') {
      this.db.object('/results/' + meetId).update({
        referee_left: 0,
        referee_left_yellow: -2
      });
    }

    if (position == 'head' || position === 'head-test') {
      this.db.object('/results/' + meetId).update({
        referee_head: 0,
        referee_head_yellow: -2
      });
    }

    if (position == 'right' || position === 'right-test') {
      this.db.object('/results/' + meetId).update({
        referee_right: 0,
        referee_right_yellow: -2
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/judge-powerlifting/judge-powerlifting.service.ts